import { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';

import OrrLayout from './OrrLayout';
import ApplicationPortal from '@/portals/application/routes';
import NewsletterRoutes from '@/features/newsletter/routes';
import SettingsRoutes from '@/features/settings/routes';
import EvaluationRoutes from '@/features/evaluationResults/routes';
import SuspenseFallback from '@/shared/ui/SuspenseFallback';

const OnboardRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/applications/onboard${search}`} replace />;
};

const OrrApp = () => (
  <Routes>
    <Route element={<OrrLayout />}>
      <Route path="" element={<Navigate to="applications" replace />} />
      <Route
        path="applications/*"
        element={
          <Suspense fallback={<SuspenseFallback />}>
            <ApplicationPortal />
          </Suspense>
        }
      />
      <Route
        path="newsletter/*"
        element={
          <Suspense fallback={<SuspenseFallback />}>
            <NewsletterRoutes />
          </Suspense>
        }
      />
      <Route path="onboard" element={<OnboardRedirect />} />
      <Route
        path="settings/*"
        element={
          <Suspense fallback={<SuspenseFallback />}>
            <SettingsRoutes />
          </Suspense>
        }
      />
      <Route
        path="evaluations/*"
        element={
          <Suspense fallback={<SuspenseFallback />}>
            <EvaluationRoutes />
          </Suspense>
        }
      />
    </Route>
  </Routes>
);

export default OrrApp;
